//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';

export default {
    name: 'ExperiencesEditPanel',
    data() {
        return {
            items: [],
            highlight: false,
            moment: moment
        }
    },
    created() {
        this.$parent.save = this.save;

        const items = this.$store.state.partner.esperienze;
        if (items) {
            for (const item of items) {
                this.items.push({
                    institution: item.ente,
                    title: item.titolo,
                    location: item.localita,
                    description: item.descrizione,
                    startDate: item.data_inizio,
                    endDate: item.data_fine,
                    open: false
                });
            }
        }
    },
    computed: {
        esperienze() {
            let arr = [];
            for (const item of this.items) {
                const startDate = item.startDate ? moment(item.startDate).format('YYYY-MM-DD') : null;
                const endDate = item.endDate ? moment(item.endDate).format('YYYY-MM-DD') : null;
                arr.push({
                    data_inizio: startDate,
                    data_fine: endDate,
                    localita: item.location,
                    titolo: item.title,
                    ente: item.institution,
                    descrizione: item.description
                });
            }
            return arr;
        }
    },
    methods: {
        
        toggle(i) {
            if (!this.items[i].open) {
                for (const k in this.items) {
                    this.items[k].open = false;
                }
                this.items[i].open = true;
            }
            else {
                this.items[i].open = false;
            }
        },

        add() {
            for (const k in this.items) {
                this.items[k].open = false;
            }

            this.items.push({
                institution: null,
                title: 'Nuova qualifica',
                description: null,
                startDate: null,
                endDate: null,
                open: true
            });
        },

        remove(index) {
            this.items.splice(index, 1);
        },

        async save() {
            if (!this.validateInput()) { return; }
            this.$store.commit('partner/set', { esperienze: this.esperienze });
            await this.$store.dispatch('partner/saveExperiences');
            this.$store.commit('panelEditPopup/close');
        },

        validateInput() {
            for (const item of this.items) {
                if (!item.institution || item.institution == '' ||
                    !item.title || item.title == ''
                ) { 
                    this.highlight = true;
                    return false;
                }
            }
            return true;
        },

        setStartDate(e, i) {
            this.items[i].startDate = e.target.value;
        },

        setEndDate(e, i) {
            this.items[i].endDate = e.target.value;
        },

        checkDateValidity(e, i) {
            const startDate = this.items[i].startDate;
            const endDate = this.items[i].endDate;
            
            if (!startDate || !endDate) {
                return e.target.classList.remove('border-red');
            }

            if(moment(startDate).isBefore(endDate)) {
                return e.target.classList.remove('border-red');
            }

            e.target.classList.add('border-red');
        }

    }
}
